export const refreshManagerService = {
  busy(): void {
    localStorage.setItem("busy", "true");
  },
  free(): void {
    localStorage.setItem("busy", "false");
  },
  isBusy(): boolean {
    const isBusyString = localStorage.getItem("busy");
    return isBusyString !== null ? JSON.parse(isBusyString) : false;
  },
};
